(function () {
    'use strict';

    angular
        .module('app.subscriptionAndBilling')
        .factory('subscriptionAndBillingService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getAllInvoicePeriod(loader) {
                    var url_getAllInvoicePeriod = $rootScope.apiUrl + 'admin/getAllInvoicePeriod';
                    return handleRequest(url_getAllInvoicePeriod, 'GET', null, loader);
                }

                function getPackageForFilter(loader) {
                    var url_getPackageForFilter = $rootScope.apiUrl + 'admin/getPackageForFilter';
                    return handleRequest(url_getPackageForFilter, 'GET', null, loader);
                }

                function getAccountSubscription(account_id, loader) {
                    var url_getAccountSubscription = $rootScope.apiUrl + 'admin/getAccountSubscription/' + account_id;
                    return handleRequest(url_getAccountSubscription, 'GET', null, loader);
                }

                function saveNewSubscription(params, loader) {
                    var url_saveNewSubscription = $rootScope.apiUrl + 'admin/saveNewSubscription';
                    return handleRequest(url_saveNewSubscription, 'POST', params, loader);
                }

                service.getAllInvoicePeriod = getAllInvoicePeriod;
                service.getPackageForFilter = getPackageForFilter;
                service.getAccountSubscription = getAccountSubscription;
                service.saveNewSubscription = saveNewSubscription;
               
                return service;
            }
        ]);
})();
